import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import toArray from 'utils/toArray';
import isAdmin from 'utils/session/isAdmin';
import { useFetchAssetSharePermissions } from './useFetchAssetSharePermissions';
function getOverallContentAudienceType(audiences) {
  if (audiences.length === 0) {
    return 'admin';
  } else if (audiences.every(function (audience) {
    return audience === 'all';
  })) {
    return 'all';
  } else if (audiences.some(function (audience) {
    return audience === 'admin';
  })) {
    return 'admin';
  }
  return 'teams';
}
export default function useGetSharingPermissions(_ref) {
  var unformattedContentIds = _ref.contentIds,
    name = _ref.name,
    contentParentPlaylistId = _ref.contentParentPlaylistId,
    _ref$playlistsToShare = _ref.playlistsToShare,
    playlistsToShare = _ref$playlistsToShare === void 0 ? [] : _ref$playlistsToShare;
  var contentIds = toArray(unformattedContentIds).filter(Boolean);
  var isAssetShare = playlistsToShare.length === 0;
  var type = isAssetShare ? 'asset' : 'playlist';
  var shareData = {
    type: type,
    playlistIds: isAssetShare ? [contentParentPlaylistId].filter(Boolean) : contentIds,
    assetIds: isAssetShare ? contentIds : undefined,
    name: name,
    overallContentAudienceType: 'teams',
    contentPermissions: []
  };
  var _useFetchAssetSharePe = useFetchAssetSharePermissions({
      enabled: isAssetShare && contentIds.length > 0 && isAdmin(),
      // We only need the extensive permissions when sharing as an admin
      assetIds: contentIds
    }),
    assetSharePermissions = _useFetchAssetSharePe.data,
    isAssetSharePermissionsLoading = _useFetchAssetSharePe.isLoading;
  if (isAssetShare) {
    shareData.overallContentAudienceType = (assetSharePermissions === null || assetSharePermissions === void 0 ? void 0 : assetSharePermissions.overallContentAudienceType) || 'admin';
    shareData.contentPermissions = (assetSharePermissions === null || assetSharePermissions === void 0 ? void 0 : assetSharePermissions.contentPermissions) || [];
  } else {
    shareData.overallContentAudienceType = getOverallContentAudienceType(playlistsToShare.map(function (playlist) {
      return playlist.audienceCalculated ? playlist.audienceCalculated : playlist.audience;
    }));
    shareData.contentPermissions = playlistsToShare.map(function (_ref2) {
      var id = _ref2.id,
        name = _ref2.name,
        audience = _ref2.audience,
        audienceCalculated = _ref2.audienceCalculated,
        teamIds = _ref2.teamIds,
        teams = _ref2.teams;
      var audienceType = audienceCalculated || audience;
      return {
        id: id,
        name: name,
        audienceType: audienceType,
        teamIds: audienceType === 'teams' ? _toConsumableArray(new Set(teamIds || (teams === null || teams === void 0 ? void 0 : teams.map(function (t) {
          return t.id;
        })) || [])) : []
      };
    });
  }
  return {
    shareData: shareData,
    isLoading: isAssetSharePermissionsLoading
  };
}